import { createRouter, createWebHistory } from 'vue-router';
import store from '../store';

// Importar componentes
import Home from '../views/Home.vue'
import Login from '../views/auth/Login.vue'
import Register from '../views/auth/Register.vue'
import Profile from '../views/auth/Profile.vue'
import SiteConfig from '../views/admin/SiteConfig.vue'
import Permisos from '../views/admin/Permisos.vue'
import IndicadoresIndex from '../views/indicadores/Index.vue' // Nuevo componente
import CSBIndex from '../views/csb/Index.vue';
import ArriendosIndex from '../views/arriendos/Index.vue';
import Contratos from '../views/arriendos/Contratos.vue';
import ContratosVigentes from '../views/arriendos/ContratosVigentes.vue';
import ContratoDetalle from '../views/arriendos/ContratoDetalle.vue';
import NotFound from '../views/NotFound.vue'
import Propiedades from '../views/arriendos/Propiedades.vue';
import SangreIndex from '../views/sangre/Index.vue';
import SangreExamenes from '../views/sangre/Examenes.vue';
import ImportarPDF from '../views/sangre/ImportarPDF.vue';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { requiresAuth: true }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { guest: true }
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
    meta: { guest: true }
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile,
    meta: { requiresAuth: true }
  },
  {
    path: '/admin/config',
    name: 'SiteConfig',
    component: SiteConfig,
    meta: { requiresAuth: true, recurso: 'admin.config' }
  },
  {
    path: '/admin/permisos',
    name: 'Permisos',
    component: Permisos,
    meta: { requiresAuth: true, recurso: 'admin.permisos' }
  },
  {
    path: '/indicadores/',
    name: 'Indicadores',
    component: IndicadoresIndex,
    meta: { requiresAuth: true, recurso: 'indicadores.valores' }
  },
  {
    path: '/csb',
    name: 'CSB',
    component: CSBIndex,
    meta: { requiresAuth: true, recurso: 'csb.items' }
  },
  {
    path: '/csb/nuevo-item',
    name: 'NuevoItem',
    component: () => import('@/views/csb/NuevoItem.vue'),
    meta: { requiresAuth: true, recurso: 'csb.items', accion: 'escribir' }
  },
  {
    path: '/csb/landing',
    name: 'CSBLanding',
    component: () => import('@/views/csb/Landing.vue'),
    meta: { requiresAuth: true, recurso: 'csb.items' }
  },
  {
    path: '/csb/editar/:item_id',
    name: 'EditarItem',
    component: () => import('@/views/csb/EditarItem.vue'),
    meta: { requiresAuth: true, recurso: 'csb.items', accion: 'escribir' }
  },
  {
    path: '/arriendos',
    component: ArriendosIndex, // Sidebar layout
    meta: { requiresAuth: true, categoria: 'arriendos' },
    children: [
      {
        path: '',
        redirect: { name: 'ContratosMorosos' }
      },
      {
        path: 'contratos-morosos',
        name: 'ContratosMorosos',
        component: () => import('@/views/arriendos/ContratosMorosos.vue'),
        meta: { recurso: 'arriendos.contratos' }
      },
      {
        path: 'contratos',
        name: 'Contratos',
        component: Contratos,
        meta: { recurso: 'arriendos.contratos' }
      },
      {
        path: 'pagos',
        name: 'Pagos',
        component: { template: '<div>Pagos (en construcción)</div>' }
      },
      {
        path: 'cobros',
        name: 'Cobros',
        component: { template: '<div>Cobros (en construcción)</div>' }
      },
      {
        path: 'propiedades',
        name: 'Propiedades',
        component: Propiedades,
        meta: { recurso: 'arriendos.propiedades' }
      },
      {
        path: 'propiedades/nueva',
        name: 'NuevaPropiedad',
        component: () => import('@/views/arriendos/NuevaPropiedad.vue'),
        meta: { recurso: 'arriendos.propiedades', accion: 'escribir' }
      },
      {
        path: 'contratos/nuevo',
        name: 'NuevoContrato',
        component: () => import('@/views/arriendos/NuevoContrato.vue'),
        meta: { recurso: 'arriendos.contratos', accion: 'escribir' }
      },
      {
        path: 'contratos-vigentes-alias',
        name: 'ContratosVigentesAlias',
        component: ContratosVigentes,
        meta: { recurso: 'arriendos.contratos' }
      },
      {
        path: 'contratos-vigentes',
        name: 'ContratosVigentes',
        component: ContratosVigentes,
        meta: { recurso: 'arriendos.contratos' }
      },
      {
        path: 'contratos/:contrato_id/detalle',
        name: 'ContratoDetalle',
        component: ContratoDetalle,
        meta: { recurso: 'arriendos.contratos' }
      },
      {
        path: 'contratos/:co_id/registrar-pago/:cb_id',
        name: 'RegistrarPago',
        component: () => import('@/views/arriendos/RegistrarPago.vue'),
        meta: { recurso: 'arriendos.cobros_pagos', accion: 'escribir' },
        props: route => ({
          co_id: route.params.co_id,
          cb_id: route.params.cb_id,
          cb_periodo: route.query.cb_periodo,
          cb_monto_uf: route.query.cb_monto_uf
        })
      },
      {
        path: 'contratos/:co_id/confirmar-pago/:cb_id',
        name: 'ConfirmarPago',
        component: () => import('@/views/arriendos/ConfirmarPago.vue'),
        meta: { recurso: 'arriendos.cobros_pagos', accion: 'escribir' },
        props: route => ({
          co_id: route.query.co_id,
          cb_id: route.query.cb_id,
          cb_periodo: route.query.cb_periodo,
          pa_fecha: route.query.pa_fecha,
          pa_monto: route.query.pa_monto,
          pa_notas: route.query.pa_notas,
          cb_monto_uf: route.query.cb_monto_uf
        })
      }
    ]
  },
  {
    path: '/sangre',
    component: SangreIndex,
    meta: { requiresAuth: true, recurso: 'sangre.examenes' },
    children: [
      { path: '', redirect: { name: 'SangreAlexander' } },
      {
        path: 'alexander',
        name: 'SangreAlexander',
        component: SangreExamenes,
        props: { rut: '16432481-8', nombre: 'Alexander' }
      },
      {
        path: 'antonio',
        name: 'SangreAntonio',
        component: SangreExamenes,
        props: { rut: '23921230-1', nombre: 'Antonio' }
      },
      {
        path: 'facundo',
        name: 'SangreFacundo',
        component: SangreExamenes,
        props: { rut: '23921246-8', nombre: 'Facundo' }
      },
      {
        path: 'benjamin',
        name: 'SangreBenjamin',
        component: SangreExamenes,
        props: { rut: '24475685-9', nombre: 'Benjamín' }
      },
      {
        path: 'importar',
        name: 'ImportarPDF',
        component: ImportarPDF,
        meta: { accion: 'escribir' }
      }
    ]
  },
  {
    path: '/empresas',
    name: 'Empresas',
    component: () => import('@/views/empresas/Index.vue'),
    meta: { requiresAuth: true, categoria: 'empresas' }
  },
  {
    path: '/empresas/bancos',
    name: 'EmpresasBancos',
    component: () => import('@/views/empresas/Bancos.vue'),
    meta: { requiresAuth: true, recurso: 'empresas.bancos' }
  },
  {
    path: '/empresas/bancos-dte',
    name: 'BancosDTE',
    component: () => import('@/views/empresas/BancosDTE.vue'),
    meta: { requiresAuth: true, recurso: 'empresas.bancos' }
  },
  {
    path: '/empresas/rcv-status',
    name: 'RCVStatus',
    component: () => import('@/views/empresas/RCVStatus.vue'),
    meta: { requiresAuth: true, recurso: 'empresas.tributario' }
  },
  {
    path: '/seguros',
    component: () => import('@/views/seguros/Index.vue'),
    meta: { requiresAuth: true, recurso: 'seguros.reembolsos' },
    children: [
      { path: '', redirect: { name: 'SegurosReembolsos' } },
      {
        path: 'reembolsos',
        name: 'SegurosReembolsos',
        component: () => import('@/views/seguros/Reembolsos.vue')
      }
    ]
  },
  {
    path: '/pjud',
    component: () => import('@/views/pjud/Index.vue'),
    meta: { requiresAuth: true, recurso: 'pjud.causas' },
    children: [
      { path: '', redirect: { name: 'PjudCausas' } },
      {
        path: 'juicios',
        name: 'PjudCausas',
        component: () => import('@/views/pjud/Causas.vue')
      },
      {
        path: 'expedientes/:id',
        name: 'PjudExpediente',
        component: () => import('@/views/pjud/Expediente.vue')
      },
      {
        path: 'mantenedor',
        name: 'PjudMantenedor',
        component: () => import('@/views/pjud/Mantenedor.vue'),
        meta: { accion: 'escribir' }
      }
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotFound
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

// Navegación protegida: sesión y permisos (meta.recurso / meta.accion / meta.categoria, el más específico gana)
export function rutaPermitida(to) {
  let recurso = null, accion = 'leer', categoria = null
  for (const r of to.matched) {
    if (r.meta.recurso) recurso = r.meta.recurso
    if (r.meta.accion) accion = r.meta.accion
    if (r.meta.categoria) categoria = r.meta.categoria
  }
  if (recurso) return store.getters['auth/puede'](recurso, accion)
  if (categoria) return store.getters['auth/puedeCategoria'](categoria)
  return true  // inicio, perfil: cualquier usuario con sesión
}

router.beforeEach(async (to) => {
  const isAuthenticated = store.getters['auth/isAuthenticated']

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isAuthenticated) return '/login'
    if (!store.getters['auth/permisos']) {
      try { await store.dispatch('auth/cargarPermisos') } catch (e) { return false }
    }
    if (!rutaPermitida(to)) return to.path === '/' ? false : '/'
    return true
  }
  // Rutas solo para invitados (login, register)
  if (to.matched.some(record => record.meta.guest) && isAuthenticated) return '/'
  return true
})

export default router;